import React from 'react'

interface CircleLoadingProps {
  size?: 'small' | 'medium' | 'large'
  color?: string | 'main' | 'sub'
  className?: string
}

export const CircleLoading: React.FC<CircleLoadingProps> = ({ size = 'medium', color = '#3b82f6', className = '' }) => {
  const sizeMap = {
    small: 'w-4 h-4',
    medium: 'w-6 h-6',
    large: 'w-12 h-12',
  }

  const fixedColor = color === 'main' ? 'var(--main-color)' : color === 'sub' ? 'var(--sub-color)' : color
  return (
    <div className={`flex justify-center items-center ${className}`}>
      <div
        className={`${sizeMap[size]} border-2 border-gray-200 border-t-current rounded-full animate-spin`}
        style={{ borderTopColor: fixedColor }}
        role="status"
        aria-label="読み込み中"
      />
    </div>
  )
}
